export default {
  vehicle: {
    detail: '车辆详情'
  },
  placeholder: {
    device_name: '设备名称',
    data_name: '数据名称'
  },
  common: {
    to: '至'
  },
  dialog: {
    export: {
      date_time_title: '导出日期时间范围'
    }
  },
  form: {
    date_time: {
      date: '日期',
      select_date: '选择日期',
      time_range: '时间范围',
      start_time: '开始时间',
      end_time: '结束时间',
      result_range: '时间范围',
      please_select_all: '请选择日期和时间范围'
    }
  }
}
